import {
  Box,
  SkeletonCircle,
  SkeletonGroup,
  SkeletonRectangle,
} from '@wix/design-system';
import React from 'react';

interface AllPlansIncludeSkeletonProps {
  numItems: number;
}
export const AllPlansIncludeSkeleton = ({
  numItems,
}: AllPlansIncludeSkeletonProps) => {
  return (
    <SkeletonGroup>
      <Box
        direction="horizontal"
        gap="SP4"
        width="100%"
        align="center"
        verticalAlign="middle"
      >
        <SkeletonRectangle height="12px" width="120px" />
        {Array.from({ length: numItems }).map((_, index) => (
          <Box
            direction="horizontal"
            gap="SP1"
            verticalAlign="middle"
            key={index}
          >
            <SkeletonCircle diameter="20px" />
            <SkeletonRectangle height="12px" width="120px" />
          </Box>
        ))}
      </Box>
    </SkeletonGroup>
  );
};
